import { cache, URL } from 'utils';
import { isWeb } from 'core';
import { FileSystem } from 'expo';

const storage = () => {
  return cache.get('fb_storage_ref');
};

const cachedRemotURL = item => {
  const url = storageRef(item);
  return cache.get('storage_url' + url);
};

const storageRef = item => `${item.is_group ? 'groups' : 'users'}/${item.user_id}/${item.file_id}${item.ext || ''}`;

export const getStorageURL = item =>
  new Promise((resolve, reject) => {
    const cached_url = cachedRemotURL(item);
    const url = storageRef(item);
    if (cached_url) {
      resolve(cached_url);
    } else {
      if (item.default_avatar) {
        const remote_url = URL.DEFAULT_AVATAR(item.user_id, item.file_id.split('.')[0], item.is_group ? 'groups' : 'users', item.size);
        cache.set('storage_url' + url, remote_url);
        resolve(remote_url);
      } else {
        storage()
          .ref(url)
          .getDownloadURL()
          .then(remote_url => {
            cache.set('storage_url' + url, remote_url);
            resolve(remote_url);
          });
      }
    }
  });

const getLocalUri = upload => `${FileSystem.cacheDirectory}/${upload.user_id}${upload.created || ''}${upload.file_id}${upload.ext || ''}`;

const getURLWeb = (upload, cb) => {
  const url = cachedRemotURL(upload);
  if (url) {
    return url;
  }
  getStorageURL(upload).then(url => cb(url, upload));
  return null;
};

const getURLNative = (upload, cb, update) => {
  const local_uri = cache.get(`local_uri${upload.user_id}${upload.created || ''}${upload.file_id}`);
  if (local_uri) {
    return local_uri;
  }
  FileSystem.getInfoAsync(getLocalUri(upload)).then(data => {
    if (data.exists) {
      cache.set(`local_uri${upload.user_id}${upload.created || ''}${upload.file_id}`, data.uri);
      cb(data.uri, upload);
    } else {
      getStorageURL(upload).then(remote_url => {
        // if the upload want to update on remote url, it must be passed in the upload object
        upload.remote_url && cb(remote_url, upload);
        const uri = getLocalUri(upload);
        const downloadResumable = FileSystem.createDownloadResumable(remote_url, uri, {}, update, null);
        downloadResumable.downloadAsync().then(() => {
          cache.set(`local_uri${upload.user_id}${upload.created || ''}${upload.file_id}`, uri);
          cb(uri, upload);
        });
      });
    }
  });
  return null;
};

export const getPercentage = downloadProgress => `%${Math.floor((downloadProgress.totalBytesWritten / downloadProgress.totalBytesExpectedToWrite) * 100)}`;

export const getURL = isWeb ? getURLWeb : getURLNative;



// WEBPACK FOOTER //
// ./src/utils/cdn.js